import React from "react";
import "./TimeSlotPicker.css";

/** Formatea un Date como "YYYY-MM-DDTHH:MM" en hora LOCAL. */
function toLocalDT(date) {
  const d = date instanceof Date ? date : new Date(date);
  const pad = n => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Suma minutos a un string datetime-local y devuelve el mismo formato. */
function addMinutesLocal(datetimeLocalStr, minutes) {
  const d = new Date(datetimeLocalStr);
  d.setMinutes(d.getMinutes() + minutes);
  return toLocalDT(d);
}

/**
 * Selector de horario de turno.
 * Muestra inicio y fin directamente (sin panel colapsable).
 * Si se pasa durationMinutes, al cambiar inicio recalcula fin automáticamente.
 * El fin siempre se puede editar manualmente.
 */
export default function TimeSlotPicker({ startTime, endTime, onStartChange, onEndChange, durationMinutes }) {
  const calcularDuracion = () => {
    if (!startTime || !endTime) return "";
    const diffMin = Math.round((new Date(endTime) - new Date(startTime)) / 60000);
    if (diffMin <= 0) return "";
    if (diffMin < 60) return `${diffMin} min`;
    const h = Math.floor(diffMin / 60);
    const m = diffMin % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  };

  const duracion = calcularDuracion();

  const handleStartChange = (e) => {
    const newStart = e.target.value;
    onStartChange(newStart);
    if (newStart) {
      const dur = durationMinutes || 30;
      // Con duración de servicio: siempre recalcula fin.
      // Sin duración: solo ajusta si fin es anterior o igual al nuevo inicio.
      if (durationMinutes || !endTime || new Date(newStart) >= new Date(endTime)) {
        onEndChange(addMinutesLocal(newStart, dur));
      }
    }
  };

  const handleEndChange = (e) => {
    const newEnd = e.target.value;
    if (startTime && new Date(newEnd) <= new Date(startTime)) {
      alert("La hora de fin debe ser posterior a la de inicio");
      return;
    }
    onEndChange(newEnd);
  };

  return (
    <div className="timeslot-picker">
      <input type="hidden" name="start" value={startTime} />
      <input type="hidden" name="end" value={endTime} />

      <div className="timeslot-fields">
        <div className="timeslot-control">
          <label htmlFor="tsp-start">Inicio</label>
          <input
            id="tsp-start"
            name="start"
            type="datetime-local"
            value={startTime}
            onChange={handleStartChange}
            required
          />
        </div>
        <div className="timeslot-sep">→</div>
        <div className="timeslot-control">
          <label htmlFor="tsp-end">Fin</label>
          <input
            id="tsp-end"
            name="end"
            type="datetime-local"
            value={endTime}
            onChange={handleEndChange}
            required
          />
        </div>
      </div>

      {duracion && (
        <div className="timeslot-duration-badge">{duracion}</div>
      )}
    </div>
  );
}
